import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// import { serviceWorkerManager } from './utils/serviceWorker'
// import { webVitalsTracker } from './utils/webVitals'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Initialize service worker for offline functionality
console.log('Service Worker initialization disabled for debugging');
// serviceWorkerManager.init().then((status) => {
//   console.log('Service Worker Status:', status);
// }).catch((error) => {
//   console.error('Service Worker initialization failed:', error);
// });

// Initialize Web Vitals tracking for performance monitoring
console.log('Web Vitals tracking initialized');
// Access webVitalsTracker to ensure it's initialized
// webVitalsTracker.getMetrics();